define( [ "./selector-sizzle" ], function() {
	"use strict";
} );



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201703161753-430ad182f9-master/~/jquery/src/selector.js
// module id = 19
// module chunks = 1